var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeactivate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "18px",
    viewBox: "0 0 19 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "desactivar") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PanelLlao-Portada",
    transform: "translate(-611.000000, -298.000000)",
    fill: "#9F9F9F"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-44",
    transform: "translate(569.500000, 291.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "desactivar",
    transform: "translate(42.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9,0 C4.05351576,0 0,4.05351576 0,9 C0,13.9464846 4.05351576,18 9,18 C13.9464846,18 18,13.9464846 18,9 C18,4.05351522 13.9464846,0 9,0 L9,0 Z M8.99999962,15.8554673 C5.22418355,15.8554673 2.1445312,12.775744 2.1445312,8.99999864 C2.1445312,7.49179569 2.64019912,6.08906098 3.47343746,4.9605103 L13.0394532,14.5265266 C11.9109376,15.3597293 10.5082033,15.8554673 9.00000039,15.8554673 L8.99999962,15.8554673 Z M14.5265571,13.0289062 L4.960541,3.47343735 C6.08905685,2.640199 7.49179091,2.1445312 8.99999381,2.1445312 C12.7758107,2.1445312 15.855463,5.22418347 15.855463,8.99999994 C15.855463,10.5082032 15.3702718,11.9003903 14.5265571,13.0289062 L14.5265571,13.0289062 Z",
    id: "Shape"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeactivate);
export default __webpack_public_path__ + "static/media/deactivate.6cfae0c2ee8be9fd5e0d38eab95b1a05.svg";
export { ForwardRef as ReactComponent };